"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/core/styles");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {},
    icon: {},
    message: {
      "& > ul, & > ol": {
        paddingLeft: theme.spacing(2)
      }
    },
    action: function action(props) {
      return {
        alignItems: props.alignAction
      };
    }
  };
});
var _default = useStyles;
exports.default = _default;